<mat-card class="status-signal-20">
  <div *ngIf="data?.noiseAlertDate" class="site-detail-alert-container">
    <span class="site-detail-alert-time">{{ data?.noiseAlertDate }}</span>
    に騒音ステータスが
    <span class="site-detail-alert-status">警報 </span>
    になりました。
  </div>
  <div class="h-4"></div>
  <div *ngIf="data?.vibrationAlertDate" class="site-detail-alert-container">
    <span class="site-detail-alert-time">{{ data?.vibrationAlertDate }}</span>
    に振動ステータスが
    <span class="site-detail-alert-status">警報 </span>
    になりました。
  </div>
  <!--
  <div class="mt-8 text-center" *ngIf="!isOuter">
    <div>
      <a
        class="underline-offset-2 underline text-blue-900"
        href="/assets/pdf/WIND2022.pdf"
        target="_blank"
      >
        ◆安全資料のリンク
      </a>
    </div>
  </div>
-->
</mat-card>
